import shuttleBoxSide from './shuttleBoxSide.vue'
export default shuttleBoxSide
